import type { FeatureModule } from '@/shell/registry/types'
import { FDE_PATHS } from '@/shell/router/semanticRoutes'

export default {
  code: 'fde',
  title: 'FDE 交付',
  routes: [
    { path: '/fde', redirect: '/fde/overview' },
    ...Object.values(FDE_PATHS).map(c => ({
      path: '/fde/' + c.path,
      component: () => import('./FdeView.vue'),
      meta: { tab: 'fde', title: c.title }
    })),
  ],
} satisfies FeatureModule
